import {observer} from "mobx-react-lite";
import React from "react";
import {InitAppComponent} from "init";
import {Outlet} from "react-router-dom";
import {GlobalMechanics} from "Application/GlobalMechanics";

// Layout root for all routes
export const RootComponent: React.FC = observer(() => {
    return <InitAppComponent>
        <div className='app__container height-100'>
            <Outlet/>
            <GlobalMechanics/>
        </div>
    </InitAppComponent>
})
